import { GeneralFacilityType } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "施設選択",
  "対象施設一覧/施設情報・異動状況登録",
  "内容確認",
  "機構へ提出",
];

const contextText = `『すべての施設が廃止』または『申出施設等のみの経営』となるため、退職手当共済は解除となります。解除のための手続きに案内します。<
※なお、引き続き共済契約の締結を希望され、以下の事由に該当する場合は、先に新設届の申請をしてから廃止・休止・経営移管の手続きを実施してください。<
　・廃止日の翌日に新たに開始する施設・事業がある場合<
　・既に他の社会福祉施設等もしくは特定介護保険施設等を新設されている場合で、未だ届出を提出されていない場合`;

const searchFormList: any = [
  {
    label: "施設種類",
    keyword: "facilityKind",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(GeneralFacilityType),
  },
  {
    label: "施設",
    keyword: "facilityName",
    type: "label",
    inputProps: {
      maxLength: 24,
    },
  },
];

const searchFormSchema = {
  facilityName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 24,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "24"),
    },
  },
};

const headList = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
    dontNeedSort: true,
  },
  {
    headTitle: "処理状況",
    dontNeedSort: true,
  },
  {
    headTitle: "加入職員数",
  },
];

export { steps, contextText, searchFormList, searchFormSchema, headList };
